import Vue from 'vue'
import App from './App.vue'
import { router } from './router/index'
import store from '@/store/index'
import '@/styles/index.scss' // global css
import '@/styles/ruoyi.scss'
import '@/styles/animate.min.css'
import '@/styles/customStyle.css'
import '@/styles/customUI.css'
import '@/plugins/index.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import registerCompenents from '@/plugins/register-components.js'

registerCompenents()
Vue.use(ElementUI, { zIndex: 3000 })
ElementUI.Dialog.props.closeOnClickModal.default = false

Vue.config.productionTip = false

import { filters } from "@/utils/filters.js";
// 定义全局自定义过滤器
Object.keys(filters).forEach((key) => {
	Vue.filter(key, filters[key]);
});

import func from "@/utils/functions";
Vue.prototype.$fn = func;

import directive from "./directive"; // directive
Vue.use(directive);

Vue.prototype.pickerOptions = {
	shortcuts: [
		{
			text: "最近一周",
			onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				picker.$emit("pick", [start, end]);
			},
		},
		{
			text: "最近一个月",
			onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
				picker.$emit("pick", [start, end]);
			},
		},
		{
			text: "最近三个月",
			onClick(picker) {
				const end = new Date();
				const start = new Date();
				start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
				picker.$emit("pick", [start, end]);
			},
		},
	],
}

new Vue({
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this
  },
  router,
  store
}).$mount('#app')
